<template>
  <div class="default-img">
    <div
      v-if="error"
      :class="[spver === 1 ? 'default-film' : 'default-sogou']"
    />
    <img
      v-else
      :src="checkHttps(src)"
      :alt="iname"
      @error="imgError"
    >
  </div>
</template>

<script>
import { checkHttpsUrl, getSpver } from '../../common/js/util';

export default {
  props: {
    src: {
      type: String,
      default: ' ',
    },
    iname: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      error: false,
    };
  },
  computed: {
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || 0;
    },
  },
  methods: {
    imgError() {
      this.error = true;
    },
    checkHttps(url) {
      return checkHttpsUrl(url);
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.default-img {
  width: 100%;
  height: 100%;
}
.default-sogou {
  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('detail/sogou');
    z-index: -1;
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}

.default-film {
  &:before {
    content: '';
    @extend %-absolute-center;
    @include sprite-item('detail/film');
  }
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.05);
  }
}
</style>
